<template>
    <div style="height: calc(var(--vh, 1vh) * 100 - 300px ); min-height:500px">
        <div class="vx-row vx-card ml-2 pb-4 customerSelect">
            <div class="vx-col xl:w-full md:w-full sm:w-full sm:mt-0 mt-2 w-full">
                <label class="vs-input--label">Chọn cuộc trò chuyện</label>
                <v-select v-model="selectZaloValue" :options="zaloOptions" :clearable="false" name="employee"
                    :reduce="item => item.value" @input="showMessage">
                </v-select>
            </div>
        </div>
        <div class="mt-8 vx-card ml-2" style="min-height: 400px;">
            <VuePerfectScrollbar ref="scrollDialog"
                                         class="scroll-area--nofications-dropdown scroll"
                                         >
            <div v-for="(msg, index) in zaloData" class="msg-grp-container" :key="index">
                <div class="flex items-start gap-2" :class="[{ 'flex-row-reverse': msg.userType === 2 }]">
                    <template v-if="msg.userType === 1">
                    <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0"
                               :class="msg.userType === 1 ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'"
                               :src="zaloAvt"></vs-avatar>
                </template>
                    <div>
                        <div class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm"
                            :class="{ 'bg-white': msg.userType === 1, 'border border-solid border-grey-light': msg.userType === 2 }"
                            :style="{ 'background-color': msg.userType === 2 ? 'rgba(var(--vs-primary), .2)' : '' }">
                            <template v-if="isJson(msg.content)">
                                <img v-if="extractHref(msg.content) !== ''" :src="extractHref(msg.content)" alt="Image" style="width: 250px;"/>
                            </template>
                            <span v-else>{{ msg.content }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </VuePerfectScrollbar>
        </div>
    </div>

</template>
<script>
import vSelect from 'vue-select';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
    components: {
        vSelect,
        VuePerfectScrollbar
    },
    props: {
        zaloHubData: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            selectZaloValue: null,
            zaloOptions: [],
            zaloData: [],
            zaloAvt:[],
        }
    },
    created() {
       
        if(this.zaloHubData){
            this.zaloOptions = this.zaloHubData.map(el => {
            return {
                label: el.employeeDisplayName,
                value: el.conversationId
            }
        })
        if (this.zaloOptions.length <2 && this.zaloOptions.length > 0){
            this.selectZaloValue = this.zaloOptions[0].value
            this.showMessage()
        }

        }

    },
    methods: {
        showMessage() {
            this.$vs.loading();
            this.$crm.post('/zalo-hub/message/find-by-condition', { conversationId: this.selectZaloValue }).then(res => {
                this.zaloData = res.data.content.reverse()
                this.zaloAvt = this.zaloHubData.map(t => {
                    return t.avatar
                })
                this.$vs.loading.close();

            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        isJson(content) {
            return content.trim().startsWith('{');
        },
        extractHref(content) {
            try {
                const data = JSON.parse(content);
                return data.href || null;
            } catch (e) {
                return null;
            }
        }

    }
}
</script>
<style>
/* .customerSelect{
    position: sticky;
    z-index:99999;
    top: 0;

}
.customerSelect + .vx-card{
    max-height: 700px;
    overflow-y: scroll;
} */
</style>
